/* eslint-disable */

// The env/version placeholders below are replaced by webpack's
// string-replace-loader at build time. IMPORTANT: that loader replaces only
// the FIRST occurrence of each token in this file, so the tokens must not
// appear anywhere above these two lines (e.g. in comments). In non-webpack
// contexts (Jest) they aren't substituted, so merge into any pre-seeded
// window.pixwel (jest.setup.js) and fall back to defaults instead of clobbering.
const _env = 'staging';
const _version = '960b547a61f5a04346eb25784c91d450cd266767';
window.pixwel = {
	...(window.pixwel || {}),
	env: _env.startsWith('{{') ? (window.pixwel?.env ?? 'development') : _env,
	version: _version.startsWith('{{') ? (window.pixwel?.version ?? null) : _version,
	apiVersion: window.pixwel?.apiVersion ?? null, // populated at runtime via system-check
};
let posthogEnabled = (window.pixwel.env === 'production' || window.pixwel.env === 'staging');
const logRocketEnabled = (window.pixwel.env === 'production' || window.pixwel.env === 'staging');
let intercomEnabled = (window.pixwel.env !== 'development');

// The placeholder below is replaced at build time by webpack's
// string-replace-loader (first occurrence only — keep the token off this
// comment). In non-webpack contexts (Jest) it isn't replaced, so fall back to
// the public dev-instance key.
const clerkKey = 'pk_test_Zmxvd2luZy1jcmF5ZmlzaC03NS5jbGVyay5hY2NvdW50cy5kZXYk';
export const CLERK_PUBLISH_KEY = clerkKey.startsWith('pk_') ? clerkKey : 'pk_test_Zmxvd2luZy1jcmF5ZmlzaC03NS5jbGVyay5hY2NvdW50cy5kZXYk';
export const OPENREPLAY_KEY = 'U0xxno52HZG7hqKPchbR';
export const OPENREPLAY_URL = 'https://openreplay.pixwel.com/ingest';
export const TAKEONE_URL = 'https://takeone.pixwel.com';
export const POSTHOG_TOKEN = 'phc_zgDxtfXLNAP5NXvsn9xRCWI2tKyMlYRyvOesqHYzPLX';
export const POSTHOG_CONFIG = { api_host: 'https://posthog.pixwel.com' };
export const MESSAGE_ENDPOINT = 'https://notifications.pixwel.com/staging/faye';
export const ASPERA_INSTALLER_ROOT = '//d3gcli72yxqn2z.cloudfront.net/connect/';
export const ASPERA_DOWNLOAD_ROOT = 'ats-aws-us-west-2'; // ats-aws-us-west-2.aspera.io
export const ICON_USER = 'icon-user';
export const ICON_GROUP = 'icon-globe';
export const JWPLAYER_KEY = 'DdkKJYHp0YIPk/58zT7tGD6gHSWfKbJppglfg7yskmM=';
export const IntercomAPI = 'ef30d123f304de60eb93ebdb931cc694dab2e19c';
export const INTERCOM_ENABLED = intercomEnabled;
export const LOG_ROCKET_ENABLED = logRocketEnabled;
export const LOG_ROCKET_APP_ID = 'bkntis/platform';
export const POSTHOG_ENABLED = posthogEnabled;
export const LANGUAGES = {
	'ar': 'ARA',
	'bg': 'BUL',
	'ca': 'CAT',
	'cs': 'CZE',
	'cy': 'CYM',
	'da': 'DAN',
	'de': 'GER',
	'el': 'GRK',
	'en': 'ENG',
	'es': 'CSP',
	'es-mx': 'LAS',
	'et': 'EST',
	'fi': 'FIN',
	'fr': 'PFR',
	'fr-ca': 'CFR',
	'he': 'HEB',
	'hi': 'HIN',
	'hr': 'CRO',
	'hu': 'HUN',
	'id': 'BAH',
	'is': 'ICE',
	'it': 'ITA',
	'ja': 'JPN',
	'ko': 'KOR',
	'lt': 'LIT',
	'lv': 'LAT',
	'ml': 'MLM',
	'nl': 'DUT',
	'nl-be': 'FLE',
	'no': 'NOR',
	'pl': 'POL',
	'pt': 'EPT',
	'pt-br': 'BPO',
	'ro': 'ROM',
	'ru': 'RUS',
	'sk': 'SLK',
	'sl': 'SLN',
	'sr': 'SER',
	'sv': 'SWE',
	'ta-in': 'TAM',
	'te': 'TEL',
	'th': 'THA',
	'tr': 'TUR',
	'uk': 'UKR',
	'vi': 'VIE',
	'zh-cn': 'PRC',
	'zh-hk': 'CAN',
	'zh-tw': 'MAN'
};

export const NTSC = {
	'pt-br': true,
	'fr-ca': true,
	is: true,
	ja: true,
	ko: true,
	mx: true,
	'zh-tw': true,
	'en-us': true
};

export const LANGUAGE_LABELS = [
	{ lang: 'en', label: 'English' },
	{ lang: 'fr', label: 'Français' },
	{ lang: 'es', label: 'Español' },
	{ lang: 'pt-br', label: 'Português Brasileiro' },
	{ lang: 'ja', label: '日本語' },
	{ lang: 'it', label: 'Italiano' },
	{ lang: 'ru', label: 'русский' },
	{ lang: 'iw', label: 'עברית' },
	{ lang: 'zh-CN', label: '中国的' },
	{ lang: 'de', label: 'Deutsch' }
];

export const PREVIEW_WATERMARK_FORMAT = {
	default: 'FULL_SCREEEN_DIAGONAL',

	'FULL_SCREEEN_DIAGONAL': {
		label: 'Full Screen Diagonal',
		class: 'px-watermark-full-screen-diagonal'
	},
	'SINGLE_CENTER': {
		label: 'Single Center',
		class: 'px-watermark-single-center'
	},
	'SINGLE_TOP_MIDDLE': {
		label: 'Single Top Middle',
		class: 'px-watermark-single-top-middle'
	},
	'SINGLE_BOTTOM_MIDDLE': {
		label: 'Single Bottom Middle',
		class: 'px-watermark-single-bottom-middle'
	}
};